import type { ProjectileSpec } from "../models/ProjectileSpec.js";
import { computeProjectileDamage } from "../models/ProjectileSpec.js";
import { resolveFireCount } from "../systems/projectileCount.js";
import { t } from "../i18n/i18n.js";
import { formatBig } from "./formatNumber.js";

/**
 * 최종 ProjectileSpec을 사람이 읽는 한 줄 요약으로 (지시문 §24 "2x Electric Homing Explosion" 류).
 * 속성/행동/충돌 라벨은 셀 약어와 동일 단어라 effect.<id> 키를 재사용한다.
 */
export function formatSpecSummary(spec: ProjectileSpec): string {
  const parts: string[] = [];
  const shotCount = resolveFireCount(spec.count);
  if (shotCount > 1) parts.push(t("spec.shots", { n: shotCount }));
  if (spec.element !== "none") parts.push(t(`effect.${spec.element}`));
  if (spec.behavior !== "straight") parts.push(t(`effect.${spec.behavior}`));
  if (spec.impact !== "normal") parts.push(t(`effect.${spec.impact}`));

  const extras: string[] = [];
  if (spec.chainCount > 0) extras.push(t("spec.chain", { n: spec.chainCount }));
  if (spec.explosionRadius > 0) extras.push(t("spec.explosion", { r: Math.round(spec.explosionRadius) }));
  if (spec.pierceCount > 0) extras.push(t("spec.pierce", { n: spec.pierceCount }));
  if (spec.splitCount > 0) extras.push(t("spec.split", { n: spec.splitCount }));
  if (spec.markChance > 0 && spec.markDamageMultiplier > 1 && spec.markHits > 0)
    extras.push(t("spec.mark", { n: spec.markHits }));

  const head = parts.length > 0 ? parts.join(" ") : t("spec.basic");
  const tail = extras.length > 0 ? ` [${extras.join(" ")}]` : "";
  return t("spec.summary", { head, damage: formatBig(computeProjectileDamage(spec)), tail });
}
